export const RECAPCTHA_KEY = "6LdY8K4cAAAAALJC-SUKeEc4vIZ_1rbglX7nHkXJ";
export const COOKIE_CONSENT_KEY = "hb!7814JGa34";
// export const COOKIE_CONSENT_KEY = "TJ2gM1647878822643";

//export const codeText = `<script id="cookie-bundle" src="http://cookieconsent.gulenayva.com/cookie-bundle.js?key=${secret_key}" type="text/javascript"></script>`;
